<mat-card class="product-card" *ngIf="product">
  <!-- Product Image Section -->
  <div class="product-image-container" [routerLink]="'/products/' + product.id">
    <img
      mat-card-image
      [src]="product.image"
      [alt]="product.name"
      class="product-image"
    />

    <!-- Sale/Clearance Badges -->
    <div class="product-badges">
      <span class="badge sale-badge" *ngIf="product.onSale">SALE</span>
      <span class="badge clearance-badge" *ngIf="product.isClearance">CLEARANCE</span>
      <span class="badge discount-badge" *ngIf="product.discountPercentage && product.discountPercentage > 0">
        -{{product.discountPercentage}}%
      </span>
    </div>

    <div class="product-arrival-badges" *ngIf="showArrivalBadges">
      <span class="badge arrival-new-badge" *ngIf="product.isNew">NEW</span>
      <span class="badge arrival-date-badge" *ngIf="arrivalText">
        {{ arrivalText }}
      </span>
    </div>

    <!-- Wishlist Button -->
    <button
      mat-icon-button
      class="wishlist-button"
      (click)="toggleWishlist($event)"
      [class.wishlist-active]="isInWishlist"
      [color]="isInWishlist ? 'warn' : 'primary'"
      [attr.aria-label]="
        isInWishlist ? 'Remove from wishlist' : 'Add to wishlist'
      "
    >
      <mat-icon>
        {{ isInWishlist ? 'favorite' : 'favorite_border' }}
      </mat-icon>
    </button>
  </div>

  <!-- Product Content -->
  <mat-card-content>
    <!-- Product Name -->
    <mat-card-title
      [routerLink]="'/products/' + product.id"
      class="product-name"
    >
      {{ product.name }}
    </mat-card-title>

    <!-- Product Brand -->
    <mat-card-subtitle *ngIf="product.brand" class="product-brand">
      {{ product.brand }}
    </mat-card-subtitle>

    <!-- Product Price -->
    <div class="product-price">
      <div class="price-container">
        <span class="price-amount">{{ product.price | currency }}</span>
        <span class="original-price" *ngIf="product.originalPrice && product.originalPrice > (product.price || 0)">
          {{ product.originalPrice | currency }}
        </span>
      </div>
    </div>
  </mat-card-content>

  <!-- Product Actions -->
  <mat-card-actions align="end">
    <button
      mat-raised-button
      color="primary"
      class="add-to-cart-button"
      (click)="addProductToCart()"
    >
      <mat-icon>shopping_cart</mat-icon>
      Add to Cart
    </button>
  </mat-card-actions>
</mat-card>
